<template>
  <div class="irrigation-intro">
    <div class="right_info1">
      上蔡县5万亩高标准农田示范区项目，位于上蔡县西南部，与遂平县5万亩高效节水灌溉示范区相连成片。以高效、节水、智能、绿色、生态为建设目标，将物联网、大数据、云计算与喷灌智能控制系统有机融合，特别是利用北汝河地表水进行灌溉，更符合高效节水灌溉建设要求。项目建成后，将成为一流的物联网、智能化的高效节水灌溉示范区，真正实现“藏粮于地、藏粮于技”。
    </div>

    <div class="right_info2">
      <div v-for="item in summary" :key="item.name" class="right_info2_item">
        <span>{{ item.name }}</span>
        <span>{{ item.value }}{{ item.unit }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
const summary = [
  { name: "新增节水灌溉面积", value: 5, unit: "万亩" },
  { name: "辐射带动周边应用高效节水灌溉面积", value: 10, unit: "万亩以上" },
];
</script>

<style lang="less" scoped>
.irrigation-intro {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.right_info1 {
  width: 100%;
  color: #cef6fe;
  font-size: 30px;
  text-align: left;
  line-height: 56px;
  padding: 0 100px 28px;
  box-sizing: border-box;
  text-indent: 2em;
}

.right_info2 {
  height: 148px;
  background: url("../../assets/img/nongye1/gbz.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 100px 0 140px;
  line-height: 148px;
  margin: 0 100px;
  box-sizing: border-box;
}

.right_info2_item {
  width: 50%;
  display: flex;
  color: #fff;
  font-size: 30px;

  span:first-child {
    text-shadow: 0 0 10px rgba(21, 241, 187, 0.5), 0 0 20px rgba(21, 241, 187, 0.8),
      0 0 30px rgba(21, 241, 187, 1);
  }

  span:last-child {
    margin-left: 30px;
    font-size: 40px;
  }

  &:last-child {
    margin-left: 300px;

    span:first-child {
      font-size: 24px;
    }
  }
}

</style>
